import KeyIcon from "@mui/icons-material/Key";
import { Alert, Avatar, Box, Button, CircularProgress, TextField, Typography } from "@mui/material";
import { resetPassword } from "aws-amplify/auth";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import CommonNonAuthenticatedPageLayout from "../components/CommonNonAuthenticatedPageLayout";
import Copyright from "../components/CopyRight";
import { useNonAuthenticated } from "../context/NonAuthenticatedContext";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { username, setUsername } = useNonAuthenticated();

  const handleResetPassword = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    await resetPassword({ username })
      .then(() => {
        setError("");
        navigate("/password-reset");
      })
      .catch((error: any) => {
        setError(error.message || "An unexpected error occurred");
        console.log(error);
      })
      .finally(() => setLoading(false));
  };

  return (
    <CommonNonAuthenticatedPageLayout>
      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
        <KeyIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        Forgot Password
      </Typography>
      <Typography color="textSecondary" sx={{ mt: 1, textAlign: "center" }}>
        Enter the username or email you signed up with and we'll send you an email with a verification code to reset
        your password on the next page.
      </Typography>
      {error && <Alert severity="error">{error}</Alert>}
      <Box component="form" onSubmit={handleResetPassword} noValidate sx={{ mt: 1, width: "100%" }}>
        <TextField
          margin="normal"
          required
          fullWidth
          id="username"
          label="Username or Email"
          name="username"
          autoComplete="username"
          autoFocus
          onChange={(e) => setUsername(e.target.value)}
        />
        <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }} disabled={loading}>
          {loading ? <CircularProgress size={24} /> : "Reset Password"}
        </Button>
        <Button type="button" fullWidth variant="outlined" sx={{ mb: 2 }} onClick={() => navigate("/")}>
          Go Back
        </Button>
      </Box>

      <Copyright sx={{ mt: 5 }} />
    </CommonNonAuthenticatedPageLayout>
  );
};

export default ForgotPassword;
